import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { isAppReady, ORGANISATIONS } from '../../store/reducers';
import { auth } from '../../store/auth/auth.selectors';
import { filter, withLatestFrom, switchMap, map } from 'rxjs/operators';
import * as actions from '../../store/actions';
import { getEntities } from '../../store/reducers';

/**
 * Guards routes that should only be accessed by logged in users who belong to the organisation
 */
@Injectable()
export class OrganisationMemberGuard implements CanActivate {
  private appReady: Observable<boolean>;
  private authenticated: Observable<boolean>;
  private organisations: Observable<{ [id: string]: any }>;
  constructor(private store: Store<any>) {
    this.appReady = this.store.select(isAppReady);
    this.authenticated = this.store.select(auth.getLoggedIn);
    this.organisations = this.store.select(getEntities(ORGANISATIONS));
  }

  public canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.appReady.pipe(
      filter((ready) => ready),
      withLatestFrom(this.organisations),
      map(([ready, organisations]) => {
        const requestedOrg = route.params['organisationId'];
        if (!organisations[requestedOrg]) {
          this.store.dispatch(
            actions.NavigateAction({
              path: ['/'],
              reason: `User does not belong to org ${requestedOrg}`,
            })
          );
          return false;
        }
        return true;
      })
    );
  }
}
